abstract class AbstractStorage {
  abstract getByKey(key: string): string | null;

  abstract setByKey(key: string, value: string | null): void;

  abstract removeByKey(key: string): void;
}

export default AbstractStorage;
